import { Inject, Pipe, PipeTransform } from '@angular/core';
import { APP_CONFIG } from '../../configurations/configurations.factory';
import { Configurations } from '../../configurations/models/configurations.model';

@Pipe({
    name: 'qrCode',
    standalone: false
})
export class QrCodePipe implements PipeTransform {

  constructor(@Inject(APP_CONFIG) private readonly config: Configurations) {
  }

  transform(value: string): string {
    return `${this.config.environmentConfig.portoBaseUrl}/qrcode_generator/raster/?text=${value}&size=150&color=black&background_color=white&imgtype=png`
  }

}
